// extracted by mini-css-extract-plugin
export default {"menubutton":"Hamburger_menubutton__Y+K86","hamburger":"Hamburger_hamburger__HDXjO","open":"Hamburger_open__KHpZ1","cross":"Hamburger_cross__fZvQ1"};